import React, { useEffect, useState } from 'react';
import styles from "./taxas.module.css";
import { FaMinus, FaPlus } from 'react-icons/fa';

interface CustomInputProps {
  initialValue?: number;
  onChange?: (newValue: number) => void; // Callback for parent updates
}

const CustomInput: React.FC<CustomInputProps> = ({ initialValue = 0, onChange }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleIncrement = () => {
    setValue(prev => {
      if (onChange) onChange(prev + 1)
      return prev + 1
    })
  };

  const handleDecrement = () => {
    setValue(prev => {
      if (onChange) onChange(prev > 1 ? prev - 1 : 0);
      return prev > 1 ? prev - 1 : 0
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numb = Number(e.target.value)
    if (!Number.isNaN(numb)) {
      setValue(numb);
      if (onChange) onChange(numb);
    }
  };

  return (
    <div className={styles.input}>
      <div className={styles.icon} onClick={handleDecrement}>
        <FaMinus style={{ color: '#D8372C' }} />
      </div>
      <input
        type="number"
        value={value}
        onChange={handleChange}
        className={styles.numero}
      />
      <div className={styles.icon} onClick={handleIncrement}>
        <FaPlus style={{ color: '#D8372C' }} />
      </div>
    </div>
  );
};

export default CustomInput;
